export enum BroadcastTab {
  CREATE = 'create',
  PUBLISHED = 'published',
}

export const CATEGORY_SUB_TYPES = [{ value: 'partner_announcement', label: 'partner_announcement' }] as const;

export const NOTIFICATION_LOCALES = [
  { code: 'ru-RU', label: 'Русский' },
  { code: 'en-US', label: 'English' },
  { code: 'kk-KZ', label: 'Қазақша' },
  { code: 'pt-BR', label: 'Português' },
] as const;

export type NotificationLocale = (typeof NOTIFICATION_LOCALES)[number]['code'];
